/* Theme application — flips the `data-theme` attribute on <html> based
 * on VoiceConfig.theme. "auto" follows the host's prefers-color-scheme
 * and re-syncs whenever the host's setting changes. "light"/"dark" pin
 * the choice and ignore the system preference.
 *
 * No state-machine, no store — just a one-shot call from main.ts. */

export type ThemeMode = "light" | "dark" | "auto";

const DARK_QUERY = "(prefers-color-scheme: dark)";

export function applyTheme(mode: ThemeMode | undefined): void {
  const resolved: ThemeMode = mode ?? "auto";
  const html = document.documentElement;

  const setFlag = (dark: boolean) => {
    html.dataset.theme = dark ? "dark" : "light";
  };

  if (resolved === "dark" || resolved === "light") {
    setFlag(resolved === "dark");
    return;
  }

  // auto — track the system preference.
  const mq = window.matchMedia(DARK_QUERY);
  setFlag(mq.matches);
  mq.addEventListener("change", (e) => setFlag(e.matches));
}
